import { lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import { useAuth } from '@/auth/auth-context'
import { AppLoadingScreen } from '@/components/AppLoadingScreen'
import { AdminShell } from '@/components/shell/AdminShell'
import { LoginPage } from '@/pages/LoginPage'

// Разделы грузятся по требованию: графики (recharts) и каталог иконок
// (полторы тысячи SVG) нужны двум-трём экранам из восьми, а в стартовый
// бандл они тянули почти мегабайт на всех.
const AnalyticsDashboardPage = lazy(() =>
  import('@/pages/analytics/AnalyticsDashboardPage').then((m) => ({ default: m.AnalyticsDashboardPage })),
)
const EntitlementsPage = lazy(() =>
  import('@/pages/entitlements/EntitlementsPage').then((m) => ({ default: m.EntitlementsPage })),
)
const CategoriesPage = lazy(() =>
  import('@/pages/categories/CategoriesPage').then((m) => ({ default: m.CategoriesPage })),
)
const MerchantVotesPage = lazy(() =>
  import('@/pages/merchants/MerchantVotesPage').then((m) => ({ default: m.MerchantVotesPage })),
)
const ProductCanonicalsPage = lazy(() =>
  import('@/pages/products/ProductCanonicalsPage').then((m) => ({ default: m.ProductCanonicalsPage })),
)
const AppUpdatePolicyPage = lazy(() =>
  import('@/pages/updates/AppUpdatePolicyPage').then((m) => ({ default: m.AppUpdatePolicyPage })),
)
const PushBroadcastPage = lazy(() =>
  import('@/pages/push/PushBroadcastPage').then((m) => ({ default: m.PushBroadcastPage })),
)
const AdminAuditLogPage = lazy(() =>
  import('@/pages/audit/AdminAuditLogPage').then((m) => ({ default: m.AdminAuditLogPage })),
)

export default function App() {
  const { status } = useAuth()

  if (status === 'checking') return <AppLoadingScreen message="Проверка доступа..." />
  if (status === 'signed-out') return <LoginPage />

  return (
    <Routes>
      <Route element={<AdminShell />}>
        <Route index element={<AnalyticsDashboardPage />} />
        <Route path="subscriptions" element={<EntitlementsPage />} />
        <Route path="categories" element={<CategoriesPage />} />
        <Route path="merchants" element={<MerchantVotesPage />} />
        <Route path="products" element={<ProductCanonicalsPage />} />
        <Route path="updates" element={<AppUpdatePolicyPage />} />
        <Route path="push" element={<PushBroadcastPage />} />
        <Route path="audit-log" element={<AdminAuditLogPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
